export class SinglePaymentRouteSettings {
	payInFull: boolean;
	isPayOffEarly?: boolean;
	selectedCustomerAccountKeys: number[];
}
